module.exports = __webpack_public_path__ + "img/user@3x.dd0cafa1.png";